import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import DashboardLayout from '../../controls/DashboardLayout';
import DashboardNavbar from '../../controls/DashboardNavbar';
import MDBox from '../../controls/MDBox';
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Snackbar } from '@mui/material';
import { Card } from 'react-bootstrap';
import MDTypography from '../../controls/MDTypography';
import ManualAyuda from '../../controls/ManualAyuda';
import DataTable from '../../controls/Tables/DataTable';
import { Link } from "react-router-dom";
import MDInput from '../../controls/MDInput';
import obtenerFechaFormateada from '../../Utils/fechas';
import MDButton from '../../controls/MDButton';
import { PencilSquare } from 'react-bootstrap-icons';
import MDBadge from '../../controls/MDBadge';
import { Cancel, CheckCircle, Engineering, Filter1 } from '@mui/icons-material';
import { postData } from '../../Utils/Http/api';
import UsuarioVencimientoClaves from './UsuarioVencimientoClaves';

function UsuarioList() {
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [emailUsuario, setEmailUsuario] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState([]);
  const [dateTime, setDateTime] = useState("");
  const [testigoDialog, setTestigoDialog] = useState({ open: false, nombre: "", guardando: false });
  const [snackbar, setSnackbar] = useState({ open: false, msg: "", severity: "success" });
  const [vencimientosAbierto, setVencimientosAbierto] = useState(false);


  const formatDate = (date) => {
    const formattedDate = new Date(date);
    const day = formattedDate.getDate().toString().padStart(2, '0');
    const month = (formattedDate.getMonth() + 1).toString().padStart(2, '0'); // El mes es devuelto de 0 a 11, por eso se le suma 1
    const year = formattedDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleFilter = () => {
    fetchData(); // Llamada desde el evento del botón
  };
  const handleClear = () => {
    setNombreUsuario('');
    setEmailUsuario('');
    fetchData();
  };

  // Gestor testigo: usuario que no inicia sesión (se crea solo con el nombre).
  const handleAbrirTestigo = () => setTestigoDialog({ open: true, nombre: "", guardando: false });
  const handleCerrarTestigo = () => setTestigoDialog({ open: false, nombre: "", guardando: false });
  const handleGuardarTestigo = async () => {
    const nombre = testigoDialog.nombre.trim();
    if (!nombre) {
      setSnackbar({ open: true, msg: "El nombre es requerido", severity: "warning" });
      return;
    }
    setTestigoDialog((prev) => ({ ...prev, guardando: true }));
    try {
      const res = await postData("UsuarioTestigoAlta", { nombre });
      if (res?.isSuccess) {
        setSnackbar({
          open: true,
          msg: `Gestor testigo creado. Su ID de usuario es ${res.value?.idUsuario}: es el que va en el archivo a importar.`,
          severity: "success"
        });
        handleCerrarTestigo();
        fetchData();
      } else {
        setSnackbar({ open: true, msg: res?.error || "Error al crear el gestor testigo", severity: "error" });
        setTestigoDialog((prev) => ({ ...prev, guardando: false }));
      }
    } catch (ex) {
      setSnackbar({ open: true, msg: ex?.detail || ex?.message || "Error al crear el gestor testigo", severity: "error" });
      setTestigoDialog((prev) => ({ ...prev, guardando: false }));
    }
  };
  useEffect(() => {
    const obtenerFechaHoraActual = () => {
      const fechaHoraActual = new Date();
      const fechaFormateada = obtenerFechaFormateada(fechaHoraActual);
      setDateTime(fechaFormateada);
    };

    obtenerFechaHoraActual();
  }, []);

  useEffect(() => {
    fetchData();
  }, []); // Ejecuta una vez al montar


  useEffect(() => {
    if (nombreUsuario.length >= 5) {
      fetchData();
    }
  }, [nombreUsuario]);

  const fetchData = async () => {
    try {
      const requser = {
        nombre: nombreUsuario,
        email: emailUsuario
      };

      const response = await postData("UsuarioListar", requser);

      const data = response.value.map((Usuario) => ({

        idUsuario: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {Usuario.idUsuario}
          </MDTypography>
        ),
        key: (
          Usuario.idUsuario
        ),
        nombre: (
          <Nombre nombre={Usuario.nombre} email={Usuario.email} telefono={Usuario.telefono} perfilNombre={Usuario.perfilNombre} esTestigo={Usuario.esTestigo} />
        ),
        datosacceso: Usuario.esTestigo ? (
          <MDTypography variant="caption" color="text" fontWeight="light">
            No inicia sesión
          </MDTypography>
        ) : (
          <DatosAcceso emailConfirmado={Usuario.emailConfirmado} fechaCambioPass={Usuario.fechaCambioPass}
            intentosFallidos={Usuario.intentosFallidos} tokenExpirado={Usuario.tokenExpirado}
            loginCambiarClave={Usuario.loginCambiarClave} />
        ),
        gestion: Usuario.esTestigo ? (
          <MDTypography variant="caption" color="text" fontWeight="light">
            -
          </MDTypography>
        ) : (
          <Gestion modalidadGestion={Usuario.modalidadGestion} gestionesMinimasDia={Usuario.gestionesMinimasDia}
            gestionesMinimasPerfil={Usuario.gestionesMinimasPerfil} />
        ),
        activo: (
          <MDBox ml={-1}>
            {Usuario.activo ? (
              <MDBadge
                badgeContent="activo"
                color="success"
                variant="gradient"
                size="sm"
              />
            ) : (
              <MDBadge
                badgeContent="desactivado"
                color="error"
                variant="gradient"
                size="sm"
              />
            )}
          </MDBox>
        ),
        action: (
          <>
            <MDBox display="flex">
              <MDBox>
                <MDTypography variant="caption" color="text" fontWeight="medium">
                  <Link to={`../UsuarioEdit/${Usuario.idUsuario}`}>
                    <MDButton variant="text" color="dark">
                      <PencilSquare color="blue" />
                    </MDButton>
                  </Link>

                </MDTypography>
              </MDBox>
            </MDBox>
          </>
        )

      }));

      setRows(data);
      setColumns([
        { Header: "ID Usuario", accessor: "idUsuario", align: "left" },
        { Header: "Usuario", accessor: "nombre", width: "35%", align: "left" },
        { Header: "Datos Acceso", accessor: "datosacceso", align: "left" },
        { Header: "Gestión de casos", accessor: "gestion", align: "left" },
        { Header: "Activo", accessor: "activo", align: "center" },
        { Header: "Acciones", accessor: "action", align: "center" },
      ]);
    } catch (ex) {
      setError(ex);

      console.log(error);
    }
  };
  // El gestor testigo no tiene correo (el que tiene es interno), perfil ni teléfono para mostrar.
  const Nombre = ({ nombre, email, telefono, perfilNombre, esTestigo }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        color={esTestigo ? "info" : "dark"}
        fontWeight="bold"
      >
        {esTestigo ? "Gestor testigo" : email}
      </MDTypography>
      <MDTypography display="block" variant="caption" color="success" fontWeight="light">
        Nombre:  {nombre}{" "}
      </MDTypography>
      {!esTestigo && (
        <>
          <MDTypography variant="caption" display="block" color="warning" fontWeight="light">
            Perfil: {perfilNombre}{" "}
          </MDTypography>
          <MDTypography variant="caption" display="block" color="info" fontWeight="light">
            Telefono :{telefono}{" "}
          </MDTypography>
        </>
      )}

    </MDBox>
  );

  // Disparador Automático de Gestiones: modalidad y gestiones mínimas por día (las del usuario o, si no tiene, las del perfil).
  const MODALIDADES = ["Voluntario", "Obligatorio", "Mixto"];
  const Gestion = ({ modalidadGestion, gestionesMinimasDia, gestionesMinimasPerfil }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="dark" fontWeight="bold">
        {MODALIDADES[modalidadGestion] ?? "Voluntario"}
      </MDTypography>
      <MDTypography display="block" variant="caption" color="text" fontWeight="light">
        {gestionesMinimasDia
          ? `Mínimo: ${gestionesMinimasDia} por día`
          : gestionesMinimasPerfil > 0
            ? `Mínimo: ${gestionesMinimasPerfil} por día (del perfil)`
            : "Sin mínimo"}
      </MDTypography>
    </MDBox>
  );

  const DatosAcceso = ({ emailConfirmado, fechaCambioPass, intentosFallidos, tokenExpirado, loginCambiarClave }) => (

    <MDBox lineHeight={1} textAlign="left">
      <MDTypography
        display="block"
        variant="caption"
        color="dark"
        fontWeight="bold"
      >
        Email Confirmado:
        {emailConfirmado ? (
          <CheckCircle color="success" /> // Icono para confirmado
        ) : (
          <Cancel color="error" /> // Icono para no confirmado
        )}
      </MDTypography>

      <MDTypography variant="caption" display="block" color={tokenExpirado ? "error" : "dark"} fontWeight="bold">
        Token Expirado:
        {tokenExpirado ? (
          <Cancel color="error" /> // Icono para intentos fallidos
        ) : (
          <CheckCircle color="success" /> // Icono para sin intentos fallidos
        )}
      </MDTypography>

      <MDTypography variant="caption" display="block" color={loginCambiarClave === true ? "error" : "dark"} fontWeight="bold">
        Debe Cambiar Contraseña:
        {loginCambiarClave === true ? (
          <Cancel color="success" /> // Icono para intentos fallidos
        ) : (
          <CheckCircle fontWeight="bold" color="error" /> // Icono para sin intentos fallidos
        )}
      </MDTypography>

      <MDTypography
        variant="caption"
        display="block"
        color={
          intentosFallidos <= 2 ? 'success' : intentosFallidos <= 4 ? 'warning' : 'error'
        }
        fontWeight="bold"
      >
        Intentos Fallidos: {intentosFallidos}
      </MDTypography>
      <MDTypography variant="caption" display="block" color="info" fontWeight="light">
        Fecha de Cambio de Contraseña: {fechaCambioPass ? formatDate(fechaCambioPass) : 'N/A'}
      </MDTypography>
      {/* Aquí puedes seguir agregando lógica similar para los otros booleanos */}
    </MDBox>
  );


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>


        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="warning"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Usuarios
                </MDTypography>
                <ManualAyuda seccion="Usuarios" />
              </MDBox>
              <MDBox pt={3} py={3} px={2} style={{ display: "flex" }}>
                <Grid>

                  <MDBox mb={2} display="flex" gap={2} flexWrap="wrap">
                    <MDInput
                      type="text"
                      name="nombre"
                      label="Nombre Usuario"
                      variant="outlined"
                      value={nombreUsuario}
                      onChange={(e) => setNombreUsuario(e.target.value)}
                    />
                    <MDInput
                      type="text"
                      name="email"
                      label="Correo electrónico"
                      variant="outlined"
                      value={emailUsuario}
                      onChange={(e) => setEmailUsuario(e.target.value)}
                    />

                    <MDButton
                      onClick={() => {
                        handleFilter();
                      }}
                      variant="gradient"
                      color="info"
                    >
                      Buscar
                    </MDButton>
                    <MDButton variant="contained" color="error" onClick={handleClear}>Limpiar</MDButton>
                    <MDButton variant="gradient" color="success" onClick={handleAbrirTestigo}>Agregar Gestor Testigo</MDButton>
                    <MDButton variant="gradient" color="warning" onClick={() => setVencimientosAbierto(true)}>Vencimiento de Claves</MDButton>
                  </MDBox>
                </Grid>
              </MDBox>
              <MDBox pt={3} py={3}
                px={2}>

                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  canSearch={false}
                  noEndBorder

                  pagination={{ color: "info", variant: "gradient" }}
                />
              </MDBox>
            </Card>
          </Grid>

        </Grid>
      </MDBox>

      <Dialog open={testigoDialog.open} onClose={handleCerrarTestigo} maxWidth="sm" fullWidth>
        <DialogTitle>Agregar Gestor Testigo</DialogTitle>
        <DialogContent dividers>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <MDTypography variant="caption" color="text">
              Un gestor testigo es un usuario que no inicia sesión. Se usa para asignarle los casos que se descartan
              al importar (su ID de usuario va en el archivo) y comparar después su resultado con el de los gestores.
            </MDTypography>
            <MDInput
              type="text"
              name="nombreTestigo"
              label="Nombre *"
              variant="outlined"
              value={testigoDialog.nombre}
              onChange={(e) => setTestigoDialog((prev) => ({ ...prev, nombre: e.target.value }))}
              inputProps={{ maxLength: 200 }}
              fullWidth
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="error" onClick={handleCerrarTestigo} disabled={testigoDialog.guardando}>
            Cancelar
          </MDButton>
          <MDButton variant="gradient" color="info" onClick={handleGuardarTestigo} disabled={testigoDialog.guardando}>
            Guardar
          </MDButton>
        </DialogActions>
      </Dialog>

      <UsuarioVencimientoClaves open={vencimientosAbierto} onClose={() => setVencimientosAbierto(false)} />

      <Snackbar open={snackbar.open} autoHideDuration={8000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} elevation={6} variant="filled">
          {snackbar.msg}
        </Alert>
      </Snackbar>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}


export default UsuarioList;